import type { TaxClosingPeriodItem } from "@/services/tax-closing-period";

import { HistoryRow } from "./history-row";

interface HistoryPanelProps {
  entries: TaxClosingPeriodItem[];
}

export function HistoryPanel({ entries }: HistoryPanelProps) {
  return (
    <div className="md:col-span-2 bg-card rounded-lg p-6 border shadow-sm">
      <h4 className="text-xs font-bold text-muted-foreground uppercase tracking-widest mb-4">
        Histórico de Alterações
      </h4>
      {entries.length === 0 ? (
        <p className="text-sm text-muted-foreground text-center py-6">
          Nenhuma alteração registrada ainda.
        </p>
      ) : (
        <div className="flex flex-col gap-2">
          {entries.map((m) => (
            <HistoryRow key={m.id} item={m} />
          ))}
        </div>
      )}
    </div>
  );
}
